import script from "./tenants.vue?vue&type=script&setup=true&lang=js"
export * from "./tenants.vue?vue&type=script&setup=true&lang=js"

import "./tenants.vue?vue&type=style&index=0&id=b95f787c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b95f787c"]])

export default __exports__